import axios from "axios";
import AbstractSitesService from './AbstractSitesService';

class SitesService extends AbstractSitesService {
  getSites() {
    return axios
      .get("/sitecore/shell/client/Applications/altola/insights/data/sites.json")
      .then(res => this.processSitesResponse(res.data))
      .catch(err => {
        console.error(err);
        return this.defaultSites;
      });
  }

  processSitesResponse(response) {
    const fetchedSites = [this.allSite];
    for (let { SiteName: siteName, ItemName: siteKey } of response) {
      fetchedSites.push({ key: siteKey, name: siteName });
    }
    return fetchedSites;
  }
}

export default new SitesService();



// WEBPACK FOOTER //
// ./src/data/SitesService.dev.js